import { render, staticRenderFns } from "./PUItem.vue?vue&type=template&id=d35e5ee2&scoped=true"
import script from "./PUItem.vue?vue&type=script&lang=js"
export * from "./PUItem.vue?vue&type=script&lang=js"
import style0 from "./PUItem.vue?vue&type=style&index=0&id=d35e5ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35e5ee2",
  null
  
)

export default component.exports